import { translate } from "@/config/translator";
import { useMfaInputEmailCode } from "./mfaInputEmailCode/useMfaInputEmailCode";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@fluentui/react-components";
import PspTextInput from "@/components/pspTextInput/pspTextInput";
import { Dispatch, SetStateAction } from "react";
import { MfaSetupContext } from "../useMfaSetup";
import PspButton from "@/components/pspButton/PspButton";

type MfaInputEmailCodeProps = {
  onNext: () => void;
  onBack: () => void;
  mfaSetupContext: MfaSetupContext;
  setMfaSetupContext: Dispatch<SetStateAction<MfaSetupContext>>;
};

export function MfaInputEmailCode({
  onBack,
  onNext,
  mfaSetupContext,
  setMfaSetupContext,
}: MfaInputEmailCodeProps) {
  const {
    lang,
    email,
    code,
    onBackWrapper,
    setCode,
    onSendCodeAgain,
    resendCooldownSeconds,
    onNextWrapper,
    showWrongCodeMessage,
  } = useMfaInputEmailCode({
    onBack,
    onNext,
    mfaSetupContext,
    setMfaSetupContext,
  });

  return (
    <>
      <DialogTitle>{translate("setup2FaTitle", lang)}</DialogTitle>
      <DialogContent className="flex flex-col gap-8">
        <p className="text-font-secondary">
          {email
            ? translate("weSentEmailCodeTo", lang, { "{email}": email })
            : ""}
        </p>

        <div className="flex flex-col gap-2 items-start">
          <PspTextInput
            label="code"
            placeholder="totpPlaceholder"
            value={code}
            onChange={setCode}
            invalidDataMessage={
              showWrongCodeMessage ? "theCodeIsIncorrect" : undefined
            }
          />

          <button
            disabled={resendCooldownSeconds !== null}
            className={`underline ${
              resendCooldownSeconds === null
                ? "cursor-pointer text-font-secondary"
                : "text-gray-400"
            }`}
            onClick={onSendCodeAgain}
          >
            {`${translate("sendCodeAgain", lang)}${
              resendCooldownSeconds ? ` (${resendCooldownSeconds})` : ""
            }`}
          </button>
        </div>
      </DialogContent>
      <DialogActions>
        <PspButton appearance="secondary" onClick={onBackWrapper}>
          {translate("back", lang)}
        </PspButton>
        <PspButton
          appearance="primary"
          disabled={code.replaceAll(" ", "").length !== 6}
          onClick={onNextWrapper}
        >
          {translate("continue", lang)}
        </PspButton>
      </DialogActions>
    </>
  );
}
